import React, {Component} from "react";
import CustodiaBanamexView from "./CustodiaBanamexView";
import {CustodyService} from "../../service/custody/CustodyService";
import ConfirmationMessage from "../../components/confirmationMessage";
import {Growl} from "primereact/growl";

export default class CustodiaBanamexContainer extends Component {
    constructor(props) {
        super(props);

        this.custodyService = new CustodyService();
        this.confirmationRefEnabled = null;
        this.setConfirmationRefEnabled = element => {
            this.confirmationRefEnabled = element
        };
        this.setConfirmationRefSave = element => {
            this.confirmationRefSave = element
        };

        this.state = {
            isLoading: false,
            username: '',
            password: '',
            domainId:'',
            domainObj: {},
            isDisabledData: true,
            oldData: {},
            domainCatalog: [],
        };

        this.onChangeData = this.onChangeData.bind(this);
        this.openConfMsgEnabled = this.openConfMsgEnabled.bind(this);
        this.openConfMsgSave = this.openConfMsgSave.bind(this);
        this.saveDataFideicomiso = this.saveDataFideicomiso.bind(this);
        this.enableForm = this.enableForm.bind(this);
        this.restartData = this.restartData.bind(this);
        this.getCustodyData = this.getCustodyData.bind(this);
        this.getDomainCatalog = this.getDomainCatalog.bind(this);
        this.saveDataFideicomisoConf = this.saveDataFideicomisoConf.bind(this);
        this.loading = this.loading.bind(this);
    }
    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    componentDidMount() {
        this.getCustodyData();
    }

    getCustodyData() {
        this.loading(true);
        this.custodyService.getCustodyData().then(res => {
            let oldDataAux = res.payload[0];
            this.setState({
                oldData: oldDataAux,
                username: oldDataAux.username,
                password: oldDataAux.password,
                domainId: oldDataAux.domainId,
            });
            this.loading(false);
            this.getDomainCatalog();
        })
    }

    getDomainCatalog(){
        this.loading(true);
        let domainIdAux = this.state.domainId;
        this.custodyService.getDomainCatalog().then(res => {
            if (res.message === "Success" || res.payload.length > 0) {
                let domainObjAux = res.payload.find((item) =>
                    item['domainId'] === domainIdAux);
                let oldDataAux = this.state.oldData;
                oldDataAux['domainObj'] = domainObjAux;
                this.setState({
                    domainCatalog: res.payload,
                    domainObj: domainObjAux,
                    oldData: oldDataAux,
                });
            } else if (res.error !== '') {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: res.error
                })
            }
            this.loading(false);
        });
    }

    saveDataFideicomisoConf(){
        let data = {
            username: this.state.username,
            password: this.state.password,
            domainObj: this.state.domainObj
        }
        this.saveDataFideicomiso(data);

    }

    restartData(){
        let oldDataAux = this.state.oldData;
        this.setState({
            username: oldDataAux.username,
            password: oldDataAux.password,
            domainObj: oldDataAux.domainObj,
        });
        this.saveDataFideicomiso(this.state.oldData);
    }

    saveDataFideicomiso(data) {
        this.loading(true);
        this.custodyService.updateCustodyData(
            data.username, data.password, data.domainObj
        ).then(resp => {
            if (resp.error !== '') {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: resp.error
                });
            } else {
                this.growl.show({
                    severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha guardado su solicitud con éxito.'
                });
                this.setState({
                    isDisabledData: true,
                });
            }
            this.loading(false);
        });
    }

    onChangeData(event) {
        const {name, value} = event.target;
        this.setState({[name]: value})
    }

    enableForm(){
        this.setState({
            isDisabledData: false,
        })

    }
    openConfMsgEnabled() {
        if (this.confirmationRefEnabled) {
            this.confirmationRefEnabled.openConfirmationMessage();
        }
    }
    openConfMsgSave() {
        if (this.state.username === '' || this.state.password === '' || !this.state.domainObj.domainId) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Los datos están incompletos'
            });
        }else {
            if (this.confirmationRefSave) {
                this.confirmationRefSave.openConfirmationMessage();
            }
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsgEnabled = <ConfirmationMessage ref={this.setConfirmationRefEnabled}
                                            invisible={true}
                                            legend="¿Está seguro que desea hacer cambios en la información?"
                                            action={this.enableForm}/>;
        this.confMsgSave = <ConfirmationMessage ref={this.setConfirmationRefSave}
                                            invisible={true}
                                            legend="¿Está seguro que desea guardar los cambios?"
                                            action={this.saveDataFideicomisoConf}/>;
        return <CustodiaBanamexView
            isDisabledData={this.state.isDisabledData}
            username={this.state.username}
            password={this.state.password}
            domainObj={this.state.domainObj}
            isLoading = {this.state.isLoading}
            messagesGrowl={messagesGrowl}
            confMsgEnabled={this.confMsgEnabled}
            confMsgSave={this.confMsgSave}
            domains={this.state.domainCatalog}
            onChangeData={this.onChangeData}
            openConfMsgEnabled={this.openConfMsgEnabled}
            openConfMsgSave={this.openConfMsgSave}
            restartData={this.restartData}
        />
    }
}